export const selectNewHireDetails = state => state.newHireDetails;